import { FormattedMessage } from "react-intl";
import { Outlet, useLocation } from "react-router";
import { loginUrlFor } from "@/auth/login-url";
import { buttonClasses } from "@/components/design/button-classes";
import { DEFAULT_APP_NAME } from "@/lib/use-app-name";
import { getConfig } from "@/lib/config";
import { AppShellFrame } from "./AppShellFrame";
import { SidebarNavView, PILLARS } from "./AppShell";

/** Public Share exposes only the listings admitted by the anonymous API. */
export const PUBLIC_SHARE_HOME = "/share";

// The chrome of an anonymous visitor: the same frame and sidebar as signed-in pages, only SHARE in it, and the login
// in place of the account tools (taken over from the public Share preparation, spark#1179). No authenticated query is
// made here: no branding, no features, no notifications.
export function PublicShareShell() {
  const location = useLocation();
  const next = `${getConfig().basePath.replace(/\/$/, "")}${location.pathname}${location.search}`;
  const pillars = PILLARS.filter((pillar) => pillar.id === "share")
    .map((pillar) => ({ ...pillar, to: PUBLIC_SHARE_HOME, items: [] }));
  return <AppShellFrame
    sidebar={(idPrefix, onNavigate) => <SidebarNavView idPrefix={idPrefix} onNavigate={onNavigate}
      appName={DEFAULT_APP_NAME} pillars={pillars} hasFeature={() => false} home={PUBLIC_SHARE_HOME} />}
    actions={<a id="public-share-login" href={loginUrlFor(next)} className={buttonClasses({ variant: "primary" })}>
      <FormattedMessage id="share.public.login" defaultMessage="Anmelden" />
    </a>}
  ><Outlet /></AppShellFrame>;
}
